import React, { Component } from "react";
import classnames from "classnames";
import _ from "i18n";

import { SimplePieChart } from "../Common/Charts/PieChart";
import { getTimeByDurationFormat } from "../../utils";
import { TiWarningOutline } from "react-icons/ti";

import CollaboratorApi from "../../services/CollaboratorServices";
import styles from "./CollaboratorSpace.local.scss";

class CollaboratorValuation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      data: [],
      error: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { period, date } = this.props;
    if (prevProps.period !== period || prevProps.date !== date) {
      this.handleUpdateCollaboratorValuation(date, period);
    }
  }

  componentDidMount() {
    const { date, period } = this.props;
    this.handleUpdateCollaboratorValuation(date, period);
  }

  handleUpdateCollaboratorValuation = (date, period) => {
    const { user, organization } = this.props;
    this.setState({ loading: true });
    CollaboratorApi.getCollaboratorValuation(
      organization.id,
      user.adminisId,
      user.uid,
      date,
      period
    )
      .then(response => {
        this.setState({
          data: response,
          loading: false
        });
      })
      .catch(error => {
        this.setState({
          error:
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors[0]
              ? error.response.data.errors[0]
              : "An error occurred",
          loading: false
        });
      });
  };

  renderRatingStars = (id, dataLength) => {
    let stars = [];
    for (let i = 0; i < dataLength; i++) {
      stars.push(id >= i);
    }

    return stars.map((s, k) => (
      <img
        key={id + k}
        alt={""}
        src={s ? "/img/icons/gold_star.svg" : "/img/icons/light_star.svg"}
      />
    ));
  };

  getValuationsFetching = () => {
    let valuationsFetching = [];
    for (let i = 0; i < 3; i++) {
      valuationsFetching.push(
        <div
          key={i}
          className={(classnames("columns medium-6 small-6"), styles.item)}
        >
          <div className={classnames(styles.icone_frame, styles.gradiant)} />
          <div className={classnames(styles.title, styles.loadingItems)}>
            <span className={styles.gradiant} />
          </div>
          <div className={classnames(styles.loadingChart, styles.loadingItems)}>
            <div className={styles.chart}>
              <span
                className={classnames(styles.gradiant, styles.span_chart)}
              />
            </div>
            <div className={styles.value}>
              <span className={styles.gradiant} />
            </div>
          </div>
        </div>
      );
    }
    return valuationsFetching;
  };

  renderValuationsDataCallout = error => {
    return (
      <div>
        <div>
          <TiWarningOutline />
        </div>
        <span>
          {error.code === 170071
            ? _("configureClassesMessage")
            : error.code === 170010
              ? _("noOrganization")
              : _("errorOccured")}
        </span>
      </div>
    );
  };

  renderValuationsData = data => {
    return (
      <div className={classnames("row", styles.scroll_items)}>
        {data &&
          data.map((valuation, k) => (
            <div key={`class-${k}`}>
              <div
                key={`sub-class-${k}`}
                className={
                  (classnames("columns medium-6 small-6"), styles.item)
                }
              >
                <div className={styles.title}>
                  <div className={styles.content}>
                    {this.renderRatingStars(k, data.length)}
                    <span>{" " + valuation.label}</span>
                  </div>
                </div>
                <div className={styles.chart}>
                  {valuation.total !== 0 ? (
                    <SimplePieChart
                      activeIndex={k}
                      data={data}
                      payload={valuation}
                      metric={"h"}
                      width={140}
                      height={140}
                    />
                  ) : (
                    <div className={styles.nullableChart}>
                      <div className={styles.firstCircle} />
                      <div className={styles.secondCircle}>
                        <span>{valuation.total}%</span>
                      </div>
                    </div>
                  )}

                  <div className={styles.value}>
                    <span>
                      {getTimeByDurationFormat(valuation.value, true)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    );
  };

  render() {
    let { data, loading, error } = this.state;
    return (
      <div className={styles.valuation}>
        <span>{_("analysisRealisedHours")}</span>
        <div className={styles.details}>
          {/*<span>{_("MoreDetails")}</span>*/}
        </div>
        {loading && (
          <div className={classnames("row", styles.scroll_items)}>
            {this.getValuationsFetching()}
          </div>
        )}
        {error ? (
          <div className={styles.error_frame}>
            {this.renderValuationsDataCallout(error)}
          </div>
        ) : (
          !loading && this.renderValuationsData(data)
        )}
      </div>
    );
  }
}

export default CollaboratorValuation;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorValuation.js